import { render, staticRenderFns } from "./Trabajadores.vue?vue&type=template&id=468866e6&scoped=true"
import script from "./Trabajadores.vue?vue&type=script&lang=js"
export * from "./Trabajadores.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Trabajadores.vue?vue&type=style&index=2&id=468866e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468866e6",
  null
  
)

export default component.exports